import Vue from 'vue';
import VueLazyload from 'vue-lazyload';
import error from '@/assets/error.png';
import loading from '@/assets/loading.gif';

Vue.use(VueLazyload, {
    preLoad: 1.3,
    error,
    loading,
    attempt: 1,
});
